import { all } from 'redux-saga/effects'

import { editAssetRootSaga } from '../state/edit-asset-slice'

export function* rootSaga() {
  yield all([editAssetRootSaga()])
}
